export default "__VITE_ASSET__9SlLFogo__"